module.exports = __webpack_public_path__ + "img/ON.0cce260d.png";